<template>

<div class="panel-body">
  <v-layout row wrap>
    <v-flex lg8 md8 sm12 xs12>
       <v-card flat>
         <v-container>
           <!--<v-btn :depressed="true" class="btn btn-success btn&#45;&#45;small btn-xs">  Active</v-btn>-->
           <v-btn :depressed="true" color="warning" round small @click="editInventory()"> <i class="fa fa-pencil"> Edit</i> </v-btn>
         </v-container>
         <v-container>
           <h2 class="m-t-none earth-color">{{singleInventory.name.toUpperCase()}} </h2>
           <br/>
           <p><b>Department Code:</b> {{singleInventory.analysis_code}} </p>
           <p><b>Income Account Code:</b> {{singleInventory.code}} </p>
           <p><b>Outlet Code:</b> {{singleInventory.sub_code}} </p>
           <p v-if="singleInventory.vat === true"><b>VAT:</b> Set </p>
           <p v-else><b>VAT:</b> Not Set </p>
           <p v-if="singleInventory.categing_levy === true"><b>Catering Levy:</b> Set </p>
           <p v-else><b>Catering Levy:</b> Not Set </p>
           <p v-if="singleInventory.ranger_marker === true"><b>Is Ranger:</b> Yes </p>
           <p v-else><b>Is Ranger:</b> No </p>
           <p v-if="singleInventory.has_extras === true"><b>Has Extras:</b> Yes </p>
           <p v-else><b>Has Extras:</b> No </p>
           <p><b>Google Analytics Code:</b> {{singleInventory.google_analytics_code}} </p>
           <p><b>Facebook Conversion Tag:</b> {{singleInventory.facebook_tag}} </p>
           <p v-if="singleInventory.update_status === 'true' || singleInventory.update_status === true">Last Updated: <b>{{formated_date_time(singleInventory.updated_at)}}</b> by <b>{{singleInventory.updated_by}}</b></p>
           <br>
           <div class = "small m-t-xs">
             <p>Added on <b>{{formated_date(singleInventory.created_at)}}</b> by <b>{{singleInventory.user}}</b></p>
             <p v-if="singleInventory.updates !== null || singleInventory.updates !== undefined">Last Updated on <b>{{formated_date_time(inventoryUpdate.created_at)}}</b> by <b>{{inventoryUpdate.user}}</b></p>
           </div>
           <br>
           <h3 class="earth-color">DETAILS : </h3>
           <span v-html="singleInventory.description"></span>
           <div class="m-t-md">
             <canvas id="lineOptions" height="60"></canvas>
           </div>
         </v-container>
       </v-card>
       <v-container>
<!--         <price-surge></price-surge>-->
<!--         <br>-->
         <inventory-availability></inventory-availability>
         <br>
         <inventory-pricing></inventory-pricing>
         <br>
         <inventory-contacts></inventory-contacts>
         <br>
         <inventory-discounts></inventory-discounts>
       </v-container>
    </v-flex>
    <v-flex lg4 md4 sm12 xs12>
      <v-container>
        <v-card flat>
          <v-container>
            <v-card-title class="earth-color"><h4>ACTIVITY SCHEDULE</h4></v-card-title>
            <v-layout row wrap>
              <v-flex lg5 md5 sm12 xs12 offset-lg2 offset-md2>
                <small class="stat-label">Today</small>
                <h4>{{inventorySchedule.today_count}}</h4>
              </v-flex>
              <v-flex lg5 md5 sm12 xs12>
                <small class="stat-label">Tomorrow</small>
                <h4>{{inventorySchedule.tomorrow_count}}</h4>
              </v-flex>
              <v-flex lg5 md5 sm12 xs12 offset-lg2 offset-md2>
                <small class="stat-label">This Week</small>
                <h4>{{inventorySchedule.this_week_count}}</h4>
              </v-flex>
              <v-flex lg5 md5 sm12 xs12>
                <small class="stat-label">Next Week</small>
                <h4>{{inventorySchedule.next_week_count}}</h4>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
        <br>
        <v-card flat>
          <v-container>
            <inventory-images></inventory-images>
          </v-container>
        </v-card>
      </v-container>
      <v-container>
        <v-card flat>
          <v-container>
            <v-btn :depressed="true" block @click="delete_status = delete_status - 1" v-if="delete_status > 0" color="warning">Delete Inventory ({{delete_status}})</v-btn>
            <v-btn :depressed="true" block @click="deleteInventory()" v-if="delete_status === 0" color="error">Delete Inventory</v-btn>
          </v-container>
        </v-card>
      </v-container>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import HotelDatePicker from 'vue-hotel-datepicker'
import InventoryVuex from '../../../mixins/Computed/Inventory/InventoryVuex'
import VueCoreImageUpload from 'vue-core-image-upload'
import InventoryPricing from './InventoryPricing'
import InventoryContacts from './InventoryContacts'
import InventoryDiscounts from './InventoryDiscounts'
import InventoryImages from './InventoryImages'
import InventoryAvailability from './InventoryAvailability'
import PriceSurge from './PriceSurge'

export default {
  components: {
    InventoryImages,
    InventoryDiscounts,
    InventoryContacts,
    InventoryPricing,
    InventoryAvailability,
    PriceSurge
  },
  data () {
    return {
      delete_status: 3,
      update: false,
      date_settings: {
        night: 'Day',
        nights: 'Days',
        'day-names': ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat'],
        'check-in': 'Start-Date',
        'check-out': 'End-Date',
        'month-names': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      }
    }
  },
  created () {
    this.$store.dispatch('get_all_activity_currencies')
    this.$store.dispatch('get_activity', this.$route.params.inventory_id)
    this.$store.dispatch('get_activity_images', this.$route.params.inventory_id)
    this.$store.dispatch('get_inventory_schedule', { inventory_id: this.$route.params.inventory_id })
  },
  computed: {
    inventoryUpdate () {
      var updates = this.singleInventory.updates
      return updates[updates.length - 1]
    }
  },
  methods: {
    deleteInventory: function () {
      var data = {
        inventory_id: this.$route.params.inventory_id,
        deleted_by: localStorage.getItem('lkjhgfdsa')
      }
      this.$store.dispatch('delete_activity', data)
    },
    editInventory: function () {
      this.$router.push({
        name: 'EditInventory',
        params: {
          inventory_id: this.$route.params.inventory_id
        }
      })
    },
    makeActive: function (publicId) {
      var data = {
        public_id: publicId,
        inventory_id: this.$route.params.inventory_id
      }
      this.$store.dispatch('make_inventory_pricing_active', data)
    },
    cancelAmendSchedule: function () {
      this.update = false
      this.inventory.public_id = ''
      this.inventory.start_date = ''
      this.inventory.end_date = ''
      this.inventory.resident_child_price = ''
      this.inventory.non_resident_child_price = ''
      this.inventory.citizen_child_price = ''
      this.inventory.resident_adult_price = ''
      this.inventory.non_resident_adult_price = ''
      this.inventory.citizen_adult_price = ''
      this.inventory.tourism_partner_discount = ''
      this.inventory.tourism_partner_comission = ''
      this.inventory.travel_agent_discount = ''
    },
    amendSchedule: function (index) {
      this.update = true
      this.inventory.public_id = this.inventoryPriceSchedule[index].public_id
      this.inventory.start_date = this.$moment(this.inventoryPriceSchedule[index].start_date).format('YYYY-MM-DD')
      this.inventory.end_date = this.$moment(this.inventoryPriceSchedule[index].end_date).format('YYYY-MM-DD')
      this.inventory.resident_child_price = this.inventoryPriceSchedule[index].resident_child_price
      this.inventory.non_resident_child_price = this.inventoryPriceSchedule[index].non_resident_child_price
      this.inventory.citizen_child_price = this.inventoryPriceSchedule[index].citizen_child_price
      this.inventory.resident_adult_price = this.inventoryPriceSchedule[index].resident_adult_price
      this.inventory.non_resident_adult_price = this.inventoryPriceSchedule[index].non_resident_adult_price
      this.inventory.citizen_adult_price = this.inventoryPriceSchedule[index].citizen_adult_price
      this.inventory.tourism_partner_discount = this.inventoryPriceSchedule[index].tourism_partner_commision
      this.inventory.tourism_partner_comission = this.inventoryPriceSchedule[index].tourism_partner_discount
      this.inventory.travel_agent_discount = this.inventoryPriceSchedule[index].travel_agent_discount
    },
    postPrice: function () {
      if (this.update === false) {
        this.$store.dispatch('post_activity_pricing', this.inventory)
      } else {
        this.$store.dispatch('update_activity_pricing', this.inventory)
      }
    },
    editFacility: function () {
      this.$router.push({
        name: 'EditFacility',
        params: {
          inventory_id: this.$route.params.inventory_id
        }
      })
    }
  },
  mixins: [InventoryVuex]
}
</script>

<style scoped>
</style>
